"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditStatus = exports.OrderType = exports.OrderStatus = exports.SubmissionStatus = void 0;
var SubmissionStatus;
(function (SubmissionStatus) {
    SubmissionStatus["Duplicate"] = "duplicate";
    SubmissionStatus["DuplicateInList"] = "duplicateInList";
    SubmissionStatus["Invalid"] = "invalid";
    SubmissionStatus["InvalidPatient"] = "invalidPatient";
    SubmissionStatus["InvalidPIC"] = "invalidPIC";
    SubmissionStatus["InvalidProvider"] = "invalidProvider";
    SubmissionStatus["MissingPatient"] = "missingPatient";
    SubmissionStatus["MissingProvider"] = "missingProvider";
    SubmissionStatus["NoRxCoverage"] = "noRxCoverage";
    SubmissionStatus["NoInsurance"] = "noInsurance";
    SubmissionStatus["Valid"] = "valid";
})(SubmissionStatus = exports.SubmissionStatus || (exports.SubmissionStatus = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["Done"] = "6done";
    OrderStatus["Error"] = "1error";
    OrderStatus["Pending"] = "4pending";
    OrderStatus["Ready"] = "3ready";
    OrderStatus["Refill"] = "0refill";
    OrderStatus["Refilled"] = "7refilled";
    OrderStatus["Reversed"] = "5reversed";
    OrderStatus["ReverseError"] = "2reverseError";
    OrderStatus["Progress"] = "7progress";
    OrderStatus["Executing"] = "8executing";
    OrderStatus["Reversing"] = "8reversing";
    OrderStatus["Intended"] = "9intended";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
var OrderType;
(function (OrderType) {
    OrderType[OrderType["Default"] = 0] = "Default";
    OrderType[OrderType["Cash"] = 1] = "Cash";
})(OrderType = exports.OrderType || (exports.OrderType = {}));
var AuditStatus;
(function (AuditStatus) {
    AuditStatus["Unsubmitted"] = "0unsubmitted";
    AuditStatus["Pending"] = "1pending";
    AuditStatus["Approved"] = "2approved";
    AuditStatus["Declined"] = "3declined";
})(AuditStatus = exports.AuditStatus || (exports.AuditStatus = {}));



//////////////////
// WEBPACK FOOTER
// ./src/shared/order.ts
// module id = 199
// module chunks = 0 1